import { LucideIconData } from 'lucide-angular';

export const PoolCaC12: LucideIconData = [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M6.34 14.83 A2 2 0 0 1 9.17 17.66' }],
  ['path', { d: 'M14.83 6.34 A2 2 0 0 0 17.66 9.17' }],
  ['path', { d: 'M9.17 14.83 L14.83 9.17' }],
];
